import React from 'react';
import Calender from './EventCalender'
import { connect } from 'react-redux';


const CampaignCalenderSettings = (props) => {
    
    const getSettingList = ()=>{
        const settingList = (props.campaignSettingsList && props.campaignSettingsList.length > 0)?props.campaignSettingsList:[];
        return settingList;
        /*let data = settingList && settingList.map((item)=>  {
            return  {...item, dateFrom : ConvertUTCDateToLocalDate(item.dateFrom),dateTo : ConvertUTCDateToLocalDate(item.dateTo)};
        });*/
        
    }
    return (
        <div>
            <Calender
                month={new Date().getMonth()+1}
                year={new Date().getFullYear()}
                preloadedEvents={getSettingList(props.campaignSettingsList)}
            />
        </div>
    );
}



const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    campaignSettingsList: (state.campaign && state.campaign.campaignSettingsList && state.campaign.campaignSettingsList.data) ? state.campaign.campaignSettingsList.data : [],
});
const mapDispatchToProps = (dispatch) => ({ });

export default connect(mapStateToProps, mapDispatchToProps)(CampaignCalenderSettings);